import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfirmPin, CurrentPin, Message, SubmitClearButton, Title } from './ClientUtil';
import { validateConfirmPin, validatePin } from './ClientValidate';
import { axiosErrorHandler, axiosPostWithHeader, axiosResponseHandler, ShowAlertError } from '../Common/axios';
import { SingleButton } from '../Login/LoginUtil';
import { encrypt } from '../Common/Util';

export function ChangePin (props) {
  const [message, setMessage] = useState('');
  const [currentpin, setCurrentpin] = useState('');
  const [pin, setPin] = useState('');
  const [confirmpin, setConfirmpin] = useState('');
  const currentpinReference = useRef();
  const pinReference = useRef();
  const confirmpinReference = useRef();
  const [errorAlert, setErrorAlert] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/profile.html', { replace: true });
    }, 100);
  }

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    switch(name) {
      case 'currentpin': setCurrentpin(value); break;
      case 'pin': setPin(value); break;
      case 'confirmpin': setConfirmpin(value); break;
      case 'message': setMessage(value); break;
      default : 
    }
  }

  const handleReset = (event) =>{
    const value="";
    setCurrentpin(value);
    setPin(value);
    setConfirmpin(value);
    setMessage(value);
    currentpinReference.current.focus();
  }

  const handleSubmit =  (event) => {
    var msg = '';
    if(msg==='') msg = validatePin(event,currentpinReference,currentpin);
    if(msg==='') msg = validateConfirmPin(event, pinReference,pin,confirmpinReference, confirmpin);
    if(msg==='' && currentpin===pin) {
      msg = "New pin can not be current pin";
    } 
    setMessage(msg); 

    if(msg==='') {
      const data = {
        oldPin: ''+encrypt(currentpin),
        newPin: ''+encrypt(pin),
        confirmPin: ''+encrypt(confirmpin),
      }
      axiosPostWithHeader("/astrologer/changepin", data,
        (response)=>{
          setMessage(axiosResponseHandler(response, currentpinReference, ()=>handleReset(), "Your pin is changed successfully"));
          if(response.data.code==='200') {
            setSuccess(true);
          }
        },
        (error)=>{
            setMessage(axiosErrorHandler(currentpinReference,error));
            setErrorAlert(error.message);
        }
      );
    }
    event.preventDefault();
  }

  return(
    <>
      <div class="m-0 p-0 row align-items-top">
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <div class="col-sm-12 col-md-8 m-0 p-2 bg-white text-black">
          <Title title="Change pin" urlcallback={handleBack}></Title>
          <div class="row m-0 p-0 w-100 border rounded">
            <div class="col m-0 p-0 justify-content-center">
              <div class="row m-0 p-0 w-100">
              <div class="col-3 d-none d-lg-block"></div>
              <div class="col-sm-12 col-lg-6">
                <Message msg={message} /> 
                {success===false?
                <form method="post" onSubmit={handleSubmit}>
                  <CurrentPin reference={currentpinReference} data={currentpin} callback={handleInput} />
                  <ConfirmPin reference={pinReference} confirmreference={confirmpinReference} value={pin} confirmvalue={confirmpin} callback={handleInput} />
                  <SubmitClearButton callback={handleReset} /> 
                </form>
                : <SingleButton title="Ok" callback={handleBack}/>
                }
              </div>  
              <div class="col-3 d-none d-lg-block"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
      </div>
    </>
  );
}

